import {IEnvironmentalSusceptibilityRow} from "../lt-ng/soil-information";

/**
 * Created by tom 9/08/22
 **/

interface EnvironmentalSusceptibilityResultBindings {

}

class EnvironmentalSusceptibilityResultController implements ng.IComponentController, EnvironmentalSusceptibilityResultBindings {
    public sibling: IEnvironmentalSusceptibilityRow;

    constructor() {
    }
}

export class EnvironmentalSusceptibilityResult implements ng.IComponentOptions {
    controller = [/* Inject constructor dependencies  */ EnvironmentalSusceptibilityResultController];

    bindings = {
        sibling: '<'
    };

    template = `<h5 ng-if="!$ctrl.sibling.factSheetURL" ng-bind-html='$ctrl.sibling.soilName' class="mar-bot-4"></h5>
    <p>
        <span ng-if="$ctrl.sibling.soilName !== 'Bare rock'">Nitrogen Leach Susceptibility: {{ $ctrl.sibling.relativenleachrisk | replaceUnicode }}<br></span>
        <span ng-if="$ctrl.sibling.soilName !== 'Bare rock'">Bypass Flow Susceptibility: {{ $ctrl.sibling.relativebypassflow | replaceUnicode }}<br></span>

        <span title="Area">Area: {{ $ctrl.sibling.proportion }}%</span>
        -
        Confidence: <span ng-class="$ctrl.sibling.confidenceClass">{{ $ctrl.sibling.confidence }}</span>
    </p>`
}
